export type ShopItemKind = 'partner';

export type PartnerType = 'gunner' | 'sword' | 'mage' | 'nurse' | 'engineer' | 'assassin' | 'tank' | 'summoner';

export interface ShopItemDefinition {
  id: string;
  kind: ShopItemKind;
  partnerType: PartnerType;
  name: string;
  tag: string;
  description: string;
  cost: number;
  color: number;
}

export const SHOP_CATALOG: readonly ShopItemDefinition[] = [
  {
    id: 'gunner',
    kind: 'partner',
    partnerType: 'gunner',
    name: '枪手',
    tag: '射击',
    description: '稳定直线弹道，优先清理最近敌人。',
    cost: 10,
    color: 0x4d8dff,
  },
  {
    id: 'sword',
    kind: 'partner',
    partnerType: 'sword',
    name: '剑士',
    tag: '武斗',
    description: '近身绞肉机，突进大范围斩击并击退敌人。',
    cost: 11,
    color: 0xffc857,
  },
  {
    id: 'mage',
    kind: 'partner',
    partnerType: 'mage',
    name: '法师',
    tag: '法术',
    description: '远程范围爆发，升星后扩大爆炸和连锁清场。',
    cost: 12,
    color: 0xb56cff,
  },
  {
    id: 'nurse',
    kind: 'partner',
    partnerType: 'nurse',
    name: '护士',
    tag: '支援',
    description: '支援续航，周期治疗并提升队伍容错。',
    cost: 11,
    color: 0x61d88f,
  },
  {
    id: 'engineer',
    kind: 'partner',
    partnerType: 'engineer',
    name: '工匠',
    tag: '支援',
    description: '布置炮台压制路线，升星后弹体爆炸。',
    cost: 12,
    color: 0xff9f45,
  },
  {
    id: 'assassin',
    kind: 'partner',
    partnerType: 'assassin',
    name: '刺客',
    tag: '武斗',
    description: '突进高爆发，优先斩杀低血量目标。',
    cost: 13,
    color: 0xff5d73,
  },
  {
    id: 'tank',
    kind: 'partner',
    partnerType: 'tank',
    name: '重装',
    tag: '武斗',
    description: '贴身抗压，周期冲击环击退周围敌人。',
    cost: 12,
    color: 0x8aa0a8,
  },
  {
    id: 'summoner',
    kind: 'partner',
    partnerType: 'summoner',
    name: '召唤师',
    tag: '法术',
    description: '召唤追踪弹体，稳定补刀远处敌人。',
    cost: 13,
    color: 0x5bd5d1,
  },
];

export function getCatalogItem(id: string) {
  const item = SHOP_CATALOG.find((candidate) => candidate.id === id);
  if (!item) {
    throw new Error(`Unknown shop item: ${id}`);
  }
  return item;
}
